import React from 'react';
import Card from '@/components/ui/Card';

const HelpText: React.FC = () => {
  return (
    <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800">
      <div className="flex items-start space-x-3">
        <span className="text-lg">🧠</span>
        <div>
          <h3 className="font-medium text-blue-900 dark:text-blue-100 mb-1">How it works</h3>
          <p className="text-blue-800 dark:text-blue-200 text-sm">
            Our AI analyzes your team's data including training sessions, wellness metrics,
            injury reports, and performance data to provide actionable insights. Select an
            analysis type and time range to get started.
          </p>
        </div>
      </div>
    </Card>
  );
};

export default HelpText;
